import { FileText, Image as ImageIcon } from "lucide-react";

// Render minimal markdown-like formatting
function renderRich(text) {
  if (!text) return null;
  // simple line break preserving + bold + bullets
  const lines = text.split("\n");
  const elements = [];
  let listBuffer = [];
  const flushList = () => {
    if (listBuffer.length) {
      elements.push(
        <ul key={`ul-${elements.length}`}>
          {listBuffer.map((li, i) => (
            <li key={i} dangerouslySetInnerHTML={{ __html: formatInline(li) }} />
          ))}
        </ul>
      );
      listBuffer = [];
    }
  };
  lines.forEach((raw, idx) => {
    const line = raw.trimEnd();
    if (/^\s*[-*]\s+/.test(line)) {
      listBuffer.push(line.replace(/^\s*[-*]\s+/, ""));
    } else if (/^#{1,3}\s+/.test(line)) {
      flushList();
      const level = line.match(/^#+/)[0].length;
      const Tag = `h${Math.min(level, 3)}`;
      elements.push(
        <Tag key={idx} dangerouslySetInnerHTML={{ __html: formatInline(line.replace(/^#+\s+/, "")) }} />
      );
    } else if (line.trim() === "") {
      flushList();
    } else {
      flushList();
      elements.push(
        <p key={idx} dangerouslySetInnerHTML={{ __html: formatInline(line) }} />
      );
    }
  });
  flushList();
  return elements;
}

function formatInline(s) {
  return s
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/\*\*(.+?)\*\*/g, "<strong>$1</strong>")
    .replace(/\*(.+?)\*/g, "<em>$1</em>")
    .replace(/`(.+?)`/g, "<code>$1</code>");
}

const FileBadge = ({ message }) => {
  if (!message.file_id) return null;
  const Icon = message.file_type === "pdf" ? FileText : ImageIcon;
  return (
    <div
      className="mb-2 inline-flex items-center gap-2 text-[11.5px] text-zinc-300 bg-[#1a1a1a] border border-[#262626] rounded-full px-3 py-1"
      data-testid="message-file-badge"
    >
      <Icon size={12} strokeWidth={1.5} />
      <span className="truncate max-w-[200px]">{message.file_name || "arquivo"}</span>
    </div>
  );
};

const ChatMessage = ({ message, streaming }) => {
  const isUser = message.role === "user";
  if (isUser) {
    return (
      <div className="flex justify-end" data-testid={`message-user-${message.id}`}>
        <div className="max-w-[80%]">
          <FileBadge message={message} />
          <div
            className="rounded-2xl rounded-tl-md px-5 py-3 text-[15px] leading-[1.65] font-light whitespace-pre-wrap break-words"
            style={{
              backgroundColor: "#4A4A4A",
              color: "#F0F0F0",
              borderLeft: "2px solid #C9A84C",
            }}
          >
            {message.content}
          </div>
        </div>
      </div>
    );
  }
  return (
    <div
      className="ai-content w-full"
      style={{ color: "#F0F0F0", fontSize: "15px", lineHeight: 1.75 }}
      data-testid={`message-assistant-${message.id}`}
    >
      {message.content ? (
        <>{renderRich(message.content)}{streaming && <span className="blink-caret" />}</>
      ) : streaming ? (
        <div className="dot-typing" data-testid="typing-indicator"><span /><span /><span /></div>
      ) : null}
    </div>
  );
};

export default ChatMessage;
